import { defineAsyncComponent } from "vue";

const ApplicationEmptyScreen = defineAsyncComponent(
  () => import("@/screens/ApplicationEmptyScreen.vue")
);
const ApplicationScreen = defineAsyncComponent(() => import("@/screens/ApplicationScreen.vue"));
const CustomTabScreen = defineAsyncComponent(() => import("@/screens/CustomTabScreen.vue"));
const DeadStageScreen = defineAsyncComponent(() => import("@/screens/DeadStageScreen.vue"));
const DocumentsScreen = defineAsyncComponent(() => import("@/screens/DocumentsScreen.vue"));
const FaqScreen = defineAsyncComponent(() => import("@/screens/FaqScreen.vue"));
const ProfileScreen = defineAsyncComponent(() => import("@/components/profile/ProfileScreen.vue"));
const WelcomeScreen = defineAsyncComponent(() => import("@/screens/welcome/WelcomeScreen.vue"));

export default {
  ApplicationEmptyScreen,
  ApplicationScreen,
  CustomTabScreen,
  DeadStageScreen,
  DocumentsScreen,
  FaqScreen,
  ProfileScreen,
  WelcomeScreen,
};
